
import React from 'react';

interface BusyIndicatorProps {
  text ?: string;
}

export default function BusyIndicator({ text }: BusyIndicatorProps) {
    return (
      <div className="min-h-screen w-screen bg-background/50 flex items-center justify-center top-0 left-0 fixed z-[1000000000]">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">{text || 'טוען...'}</p>
        </div>
      </div>
    );
}